import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollBar: SxStyle = {
  maxHeight: (p) => p.spacing(24.25),
};
